import { useSendCommand } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { SaveViewOptions } from '../../../api/commands';
import { StorymapState, ViewType } from '../../types';
import { currentViewOptions } from '../../use';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetShouldShowPersonaBlock extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetShouldShowPersonaBlock';

    public constructor(public isEnabled: boolean) {
        super(SetShouldShowPersonaBlock.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetShouldShowPersonaBlock): Promise<boolean> => {
    useSendCommand(action, {
        createCommand: () =>
            new SaveViewOptions(
                state.id,
                state.currentViewType,
                currentViewOptions.value.isShowPrioritization,
                currentViewOptions.value.isShowAnnotation,
                action.isEnabled,
                currentViewOptions.value.isShowIssueType,
                currentViewOptions.value.isShowAssignee
            ),
    });

    return true;
};

const reducer = (state: StorymapState, action: SetShouldShowPersonaBlock): void => {
    if (state.currentViewType === ViewType.Discovery) {
        state.discoveryViewOptions.isShowPersonaBlock = action.isEnabled;
    }

    if (state.currentViewType === ViewType.Planning) {
        state.planningViewOptions.isShowPersonaBlock = action.isEnabled;
    }

    if (state.currentViewType === ViewType.Backlog) {
        state.backlogViewOptions.isShowPersonaBlock = action.isEnabled;
    }
};

//@ts-ignore
registerMiddleware(SetShouldShowPersonaBlock.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetShouldShowPersonaBlock.ACTION_TYPE, reducer);
